import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    "CultureSelectionNavBarItem": () => import("./components/nav-bar-items/CultureSelectionNavBarItem.vue"),
    "SCSPlotMap": {
        meta: {
            i18nDescrKey: "scs-plot-map",
            filters: ["s-c-leader-select-nav-bar-item", "farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/SCSPlotMap.vue")
    },
    "SCSPlotListTile": {
        meta: {
            i18nDescrKey: "scs-plot-list",
            filters: ["s-c-leader-select-nav-bar-item", "farm-select-nav-bar-item", "campaign-select-nav-bar-item",
                "culture-selection-nav-bar-item"],
            pinnable: true,
        },
        component: () => import("./components/tiles/SCSPlotListTile.vue")
    },
    "SCSPlantingTable": {
        meta: {
            i18nDescrKey: "hco-table-performance-tile-title",
            filters: ["s-c-leader-select-nav-bar-item", "farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/SCSPlantingTable.vue")
    },
    "HCOBarChart": {
        meta: {
            i18nDescrKey: "hco-bar-chart-tile-title",
            pinnable: true,
            filters: ["s-c-leader-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            tag: "STANDARD_PORTAL"
        },
        component: () => import("./components/tiles/HCOBarChart.vue")
    },
    "HCOContractedBarChart": {
        meta: {
            i18nDescrKey: "hco-contracted-bar-chart-tile-title",
            pinnable: true,
            filters: ["s-c-leader-select-nav-bar-item", "campaign-select-nav-bar-item"]
        },
        component: () => import("./components/tiles/HCOContractedBarChart.vue")
    },
    "ProseccoPlotMap": {
        meta: {
            i18nDescrKey: "prosecco-plot-map",
            filters: ["s-c-leader-select-nav-bar-item", "farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD"
        },
        component: () => import("./components/tiles/prosecco-tiles/ProseccoPlotMap.vue")
    },
    "ProseccoPlantingsTable": {
        meta: {
            i18nDescrKey: "prosecco-table-performance-tile-title",
            filters: ["s-c-leader-select-nav-bar-item", "farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "PROSECCO"
        },
        component: () => import("./components/tiles/prosecco-tiles/ProseccoPlantingsTable.vue")
    },
};

export default globals;
